<template>
    <div class="layout-step" >
        <div :class="[isDesktop ? 'desktop-layout-step': 'mobile-layout-step']">
            <div class="step-item" v-for="(item,index) in stepList" :key="item.version">
                <div class="step-item-left">
                    <div class="step-item-left-box">
                        <div class="step-point">
                            <div class="circle" >
                            {{ index + 1 }}
                            </div>
                        </div>
                        <!-- <div class="step-line" v-if="index != stepList.length - 1" /> -->
                    </div>
                </div>
                <div class="step-item-right">
                    <div class="step-item-title" :class="{ 'step-item-title-selected': titleSelected }" @click="handleTitleClick(item)">
                        {{ item.title }}
                    </div>
                    <span class="step-item-subTitle" v-if="item.subTitle" >
                        {{ item.subTitle }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useBasicStore from '~/store/modules/basic'
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import CommonImage from '~/components/CommonImage/CommonImage.vue'
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage } = storeToRefs(systemLanguageStore)
const { t } = useI18n()
const localePath = useLocalePath()

const props = defineProps<{
    stepList: any[]
    titleSelected: boolean
}>()

const emit = defineEmits<{
    (e: 'titleClick', item: any): void
}>()

const handleTitleClick = (item: any) => {
    console.log(item, 'item')
    if (!item.titleSelected) {
        return
    }
    emit('titleClick', item)
}

</script>

<style scoped lang="scss">
@use "./index.scss" as *;
@use "./mobile.scss" as *;
</style>